import { FC } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";

interface SectionWithHeaderListI {
	list: {
		name: string;
		description: string;
	}[];
}

export const SectionWithGridList: FC<SectionWithHeaderListI> = ({ list }) => {
	return (
		<div className='bg-secondary'>
			<div className='mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:py-24 lg:px-8'>
				<dl className='mt-12 space-y-10 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8'>
					{list.map((feature) => (
						<div key={feature.name} className='relative'>
							<dt>
								<CheckIcon
									className='absolute h-6 w-6 text-white'
									aria-hidden='true'
								/>
								<p className='ml-9 text-lg font-bold leading-6 text-gray-800'>
									{feature.name}
								</p>
							</dt>
							<dd className='mt-2 ml-9 text-base text-gray-700'>
								{feature.description}
							</dd>
						</div>
					))}
				</dl>
			</div>
		</div>
	);
};
